import { integrationLayer } from "app/services/integrationLayerService";
import { Cart } from "types/CartTypes";

type GiftCertificateItem = {
  name: string;
  theme: string;
  amount: number;
  message: string;
  quantity: number;
  recipient: { email: string; name: string };
  sender: { email: string; name: string };
};

type CreateCartWithGC = {
  channelId: number;
  giftCertificate: GiftCertificateItem;
};

type AddGCToCart = {
  cartId: string;
  giftCertificate: GiftCertificateItem;
};

const giftCertificateApi = integrationLayer.injectEndpoints({
  endpoints: (builder) => ({
    createCartWithGiftCertificate: builder.mutation({
      query: ({ channelId, giftCertificate }: CreateCartWithGC) => ({
        url: `/bc/cart`,
        method: "POST",
        body: {
          channel_id: channelId,
          line_items: [],
          gift_certificates: [giftCertificate],
        },
      }),
      transformResponse: (res: any) => res.data as Cart,
    }),
    addGiftCertificateToCart: builder.mutation({
      query: ({ cartId, giftCertificate }: AddGCToCart) => ({
        url: `/bc/cart/${cartId}/items`,
        method: "POST",
        body: {
          gift_certificates: [giftCertificate],
        },
      }),
      transformResponse: (res: any) => res.data as Cart,
    }),
    removeGiftCertificateFromCart: builder.mutation({
      query: ({ cartId, itemId }: { cartId: string; itemId: string }) => ({
				url: `/bc/cart/${cartId}/item/${itemId}?include=redirect_urls,line_items.gift_certificates`,
        method: "DELETE",
      }),
      transformResponse: (res: any) => {
        if (!res || !res.data) {
          return undefined;
        }
        return res.data as Cart;
      },
    }),
    getGiftCertificateValues: builder.query({
      query: () => ({
        url: `/bc/gift-certificate/values`,
        method: "GET",
      }),
      transformResponse: (res: any) =>
        (res.data.values as number[]).map((v) => ({ value: v, label: `${v}` })),
    }),
  }),

});

export const {
  useCreateCartWithGiftCertificateMutation,
  useAddGiftCertificateToCartMutation,
  useRemoveGiftCertificateFromCartMutation,
  useGetGiftCertificateValuesQuery,
} = giftCertificateApi;

export default giftCertificateApi;